/*
 * @Author: your name
 * @Date: 2021-09-22 10:02:54
 * @LastEditTime: 2022-03-22 15:58:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web-admin\src\api\settings.js
 */

import {
    axios
} from './../plugin/axios'


export default {
    updateUserInfo(id, params) {
        return axios.post(`/api/base/user/updatebyuser/${id}`, params)
    },
    getUserInfo(id) {
        return axios.get(`/api/base/user/${id}`)
    },
    getMessageList(params) {
        return axios.post(`/api/base/notify/list`, params)
    },
    readMessage(params) {
        return axios.post(`/api/base/notify/read-state`, params)
    },
}